import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';

const initMissionStatementSections = () => {
    [...document.querySelectorAll('.mission-statement-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initMissionStatementSection(item));
};

const initMissionStatementSection = (section) => {
    section.dataset.init = "true";

    const sectors = JSON.parse(section.querySelector('.sectors-state').dataset.sectors);
    const canvas = section.querySelector('.donutChart');
    const ctx = canvas.getContext('2d');
    const container = section.querySelector('#chart-container');

    function hexToRgba(hex, alpha = 1) {
        const h = hex.replace('#','');
        const bigint = parseInt(h, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    const baseColors = sectors.map(s => s.color);

    const donutChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [{
                data: Array(sectors.length).fill(1),
                backgroundColor: baseColors.map(c => hexToRgba(c, 1)),
                borderColor: baseColors.map(() => 'rgba(255,255,255,0.5)'),
                borderWidth: 0,
                borderRadius: 8,
                spacing: 8
            }]
        },
        options: {
            plugins: { tooltip: { enabled: false }},
            animation: { duration: 400 },
            maintainAspectRatio: false,
            cutout: '55%',
            events: ['mousemove','mouseout','mouseleave','click','touchstart','touchmove']
        }
    });

    function clearExtras() {
        container.querySelectorAll('.icon-svg, .label').forEach(el => el.remove());
    }

    function placeIconsAndLabels() {
        clearExtras();
        const width = canvas.width;
        const height = canvas.height;
        const cx = width / 2;
        const cy = height / 2;

        const radiusIcon = width * 0.38;
        const radiusLabel = width * 0.7;

        for (let i = 0; i < sectors.length; i++) {
            const angle = (i + 0.5) * (2 * Math.PI / sectors.length) - Math.PI / 2;

            const svgEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svgEl.setAttribute('viewBox', '0 0 40 40');
            svgEl.classList.add('icon-svg');
            svgEl.innerHTML = sectors[i].icon;
            svgEl.style.left = `${cx + Math.cos(angle) * radiusIcon}px`;
            svgEl.style.top = `${cy + Math.sin(angle) * radiusIcon}px`;
            container.appendChild(svgEl);

            const label = document.createElement('div');
            label.className = 'label';
            label.textContent = sectors[i].name || sectors[i].label;
            label.style.left = `${cx + Math.cos(angle) * radiusLabel}px`;
            label.style.top = `${cy + Math.sin(angle) * radiusLabel}px`;
            container.appendChild(label);
        }
    }

    placeIconsAndLabels();
    window.addEventListener('resize', () => setTimeout(placeIconsAndLabels, 100));


    function setDimmed(activeIndex){
        const ds = donutChart.data.datasets[0];
        ds.backgroundColor = baseColors.map((c, i) =>
            activeIndex === null ? hexToRgba(c, 1) :
                (i === activeIndex ? hexToRgba(c, 1) : hexToRgba(c, 0.2))
        );
        donutChart.update('none');
    }

    function restoreAll(){
        setDimmed(null);
    }

    const sliderEl = section.querySelector('.qt-services-section__slider');
    const swiper = new Swiper(sliderEl, {
        modules: [EffectFade],
        slidesPerView: 1,
        autoHeight: true,
        allowTouchMove: false,
        effect: 'fade',
        speed: 200,
        fadeEffect: { crossFade: true }
    });

    canvas.addEventListener('mousemove', (evt) => {
        const points = donutChart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, true);

        if (points.length) {
            const idx = points[0].index;
            setDimmed(idx);
            swiper.slideTo(idx);
            sliderEl.style.opacity = '1';
        } else {
            restoreAll();
            sliderEl.style.opacity = '0';
        }
    });

    canvas.addEventListener('mouseleave', restoreAll);

    // SVG hover logic
    const svgWrapper = section.querySelector('.qt-services-section__wrapper');
    const svg = svgWrapper.querySelector('svg');
    const parts = [...section.querySelectorAll('.circle-item')];

    svg.addEventListener('mouseover', e => {
        const part = e.target.closest('.circle-item');
        if (!part) return;

        parts.forEach(p => p.classList.remove('qt-services-section__part_active'));
        part.classList.add('qt-services-section__part_active');

        const slideIndex = parts.findIndex(p => p.dataset.id === part.dataset.id);
        if (slideIndex !== -1) swiper.slideTo(slideIndex);
    });

    svgWrapper.addEventListener('mouseleave', () => {
        parts.forEach(p => p.classList.remove('qt-services-section__part_active'));
    });
};

export { initMissionStatementSections };
